import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';
import { Router } from '@angular/router';



export const AuthInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  
  const router = inject(Router);
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: token
      }
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
     
        return from(authService.refreshToken(authService.getUser().email)).pipe(
          switchMap((response: any) => {
       
            localStorage.setItem('accessToken', response.data.token);
            
            const clonedRequest = request.clone({
              setHeaders: {
                Authorization: response.data.token
              }
            });
            return next(clonedRequest);
          })
        );
      } else if (error.status === 419){
       
        localStorage.removeItem('accessToken');
      
        router.navigate(['iniciar-sesion'])
        return throwError(error);
      } else if (error.status === 420){
       
        return throwError(error);
      }else {
        return throwError(error);
      }
      return throwError(error);
    })
  );
}
